<template>
  <div class="tabs-item" ref="wrapper">
    <div class="toolbar-row">
      <div class="order-tab-row">
        <el-tabs v-model="activeOrderTab" @tab-click="handleOrderTabChange">
          <el-tab-pane :label="`全部(${tabCountMap.allQty})`" name="all">
            <template slot="label">
              <el-tooltip effect="light">
                <el-button slot="content" type="text">全部：统计以订单商品行为维度的数量</el-button>
                <el-button type="text">{{`全部(${tabCountMap.allQty})`}}</el-button>
              </el-tooltip>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="`异常(${tabCountMap.abnormalQty})`" name="abnormal"></el-tab-pane>
          <el-tab-pane :label="`正常(${tabCountMap.normalQty})`" name="normal"></el-tab-pane>
          <el-tab-pane :label="`未回复(${tabCountMap.unrepliedQty})`" name="unreplied"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="toolbar-buttons">
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
        <el-button type="primary" size="small" @click="exportDetailExcel">导出明细</el-button>
        <el-button type="primary" size="small" @click="tableVisible = true">表格设置</el-button>
      </div>
    </div>

    <el-table
      ref="table"
      border
      :data="tableData"
      :max-height="maxHeight"
      highlight-current-row
      @sort-change="handleSortChange"
      v-if="tableReload"
      v-loading="loading2"
    >
      <el-table-column
        v-for="item in columnData"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width"
        :sortable="item.sortable ? 'custom' : false"
        :align="item.align"
        :fixed="item.fixed"
        show-overflow-tooltip
      >
        <template slot="header">
          <template v-if="item.label === '订单交期'">
            <span>订单交期</span>
            <el-tooltip effect="dark" placement="top">
              <span class="el-icon-warning-outline"></span>
              <div slot="content">
                紧急：取“VSO”“特急”“紧急程度-高”中“未来10天”“10天之后”的部分。<br />
                超期：取“VSO”“特急”“紧急程度-高/中/低/默认”中“历史缺货”的部分。<br />
                即将超期、正常：参照原订单交期逻辑。
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <span>{{ item.label }}</span>
          </template>
        </template>

        <template slot-scope="scope">
          <template v-if="['平台单号', '电商单号', '顾客ID', '收货地址', '店铺名称'].includes(item.label)">
            <remark :content="scope.row[item.prop]"></remark>
          </template>

          <template v-else-if="item.label === '订单交期'">
            <div class="orderDeliveryStatusStr-cls">
              <span>{{ getOrderDeliveryStatusText(scope.row.orderDeliveryStatus) }}</span>
              <span v-if="scope.row.orderDeliveryStatus == 3">
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
              </span>
              <span v-if="scope.row.orderDeliveryStatus == 2">
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
              </span>
              <span v-if="scope.row.orderDeliveryStatus == 1 || scope.row.orderDeliveryStatus == 0">
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
                <el-image
                  style="width: 14px; height: 14px"
                  :src="fireIcon"
                  :fit="`fill`"
                ></el-image>
              </span>
            </div>
          </template>

          <template v-else-if="['缺货商品数', '缺货产品数', '缺货包件数'].includes(item.label)">
            <el-link :underline="false" type="success" @click="openGoodsDetailDialog(scope.row)">
              {{ scope.row[item.prop] }}
            </el-link>
          </template>

          <template v-else>
            {{ getCellValue(scope.row, item) }}
          </template>
        </template>
      </el-table-column>

      <el-table-column label="日志" fixed="right" prop="stockPackNumber" align="center" width="120">
        <template slot-scope="scope">
          <el-link :underline="false" type="success" @click="openJournalDialog(scope.row)">查看操作日志</el-link>
        </template>
      </el-table-column>
    </el-table>

    <div class="footer-row">
      <div class="refresh-time">
        <span>{{ timeText.updateContent ? '数据刷新时间：' : '' }}</span>
        <span>{{ timeText.latestUpdateTime || '' }}</span>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total"
      />
    </div>

    <goods-detail-dialog
      :visible.sync="goodsDetailDialogVisible"
      :row-data="currentGoodsDetailRow"
      v-if="goodsDetailDialogVisible"
    />

    <el-dialog
      :visible.sync="journalDialogVisible"
      title="操作日志"
      width="70%"
      :close-on-click-modal="false"
    >
      <el-table
        border
        :data="dialogData"
        height="360"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column label="回复包件编码" prop="packCode" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="回复包件名称" prop="packName" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="回复时间" prop="packReplyTime" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="出货量" prop="shipmentNum" min-width="100"></el-table-column>
        <el-table-column label="预计出货时间" prop="packExpectShipmentTime" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="优先级数据更新时间" prop="priorityUpdateBeforeTime" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="最新订单预计出货时间" prop="latestGoodsShipmentTime" min-width="180" show-overflow-tooltip> </el-table-column>
        <el-table-column label="原因" prop="changeReason" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-dialog>

    <custom-table
      v-model="tableVisible"
      :tableDataSet="tableDataSet"
      v-if="tableVisible"
      @closeAddForm="closeAddForm"
      @confirm="confirm"
    ></custom-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import customProps from './customProps.mixin'
import GoodsDetailDialog from './components/goodsDetailDialog/goodsDetailDialog.vue'
import fire from '@/assets/Fire.png'

export default {
  name: 'OperationAnalysisOrders',
  components: { GoodsDetailDialog },
  mixins: [customProps],
  props: ['data', 'timeText'],
  data () {
    return {
      orderParams: {},
      tableData: [],
      loading: false,
      loading2: false,
      paginationOpt: {
        pageSizes: [30, 100, 500, 1000],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      journalDialogVisible: false,
      goodsDetailDialogVisible: false,
      currentGoodsDetailRow: null,
      dialogData: [],
      scrollTop: 0,
      activeOrderTab: 'all',
      tabCountMap: {
        allQty: 0,
        abnormalQty: 0,
        normalQty: 0,
        unrepliedQty: 0
      },
      fireIcon: fire
    }
  },
  computed: {
    formData () {
      return this.data
    },
    maxHeight () {
      const winH = document.documentElement.clientHeight
      return `${winH - 404}px`
    },
    ...mapGetters({
      global_outOfStockRecordsData: 'global_outOfStockRecordsData'
    })
  },
  activated () {
    this.getScroll()
  },
  mounted () {
    this.$refs.table.bodyWrapper.addEventListener('scroll', this.handleTableScroll, false)
    this.init()
    this.queryTabCount()
    this.showOutOfstockRecordsModel()
  },
  deactivated () {
    this.$refs.table && this.$refs.table.bodyWrapper.removeEventListener('scroll', this.handleTableScroll, false)
  },
  methods: {
    handleTableScroll (event) {
      this.scrollTop = event.target.scrollTop
    },
    getScroll () {
      setTimeout(() => {
        const tableBody = this.$el.querySelector('.el-table__body-wrapper')
        if (tableBody) tableBody.scrollTop = this.scrollTop
      }, 10)
    },
    search () {
      this.paginationOpt.pageNum = 1
      this.init()
      this.queryTabCount()
    },
    buildFilterData (includeReplyStatus = true) {
      const replyStatusMap = {
        all: '',
        abnormal: '异常',
        normal: '正常',
        unreplied: '未回复'
      }
      const filterData = {
        ...this.formData,
        ...this.orderParams,
        excludeWarehouseStockOutOrder: true,
        excludeInWarehouseStockOutOrder: true
      }
      if (includeReplyStatus) {
        filterData.replyStatus = replyStatusMap[this.activeOrderTab]
      }
      return filterData
    },
    getCellValue (row, column) {
      if (column.prop === 'systemDeliveryCycle') {
        return row.systemDeliveryCycle || row.deliveryCycle || row.goodsDeliveryCycle || ''
      }
      if (column.prop === 'orderPriority') {
        return row.orderPriority || row.priority || row.priorityName || row.orderPriorityName || ''
      }
      return row[column.prop]
    },
    getOrderDeliveryStatusText (status) {
      const statusMap = {
        0: '超期',
        1: '紧急',
        2: '即将超期',
        3: '正常'
      }
      return statusMap[status] || ''
    },
    isWarehouseStockOutOrder (row) {
      const flagFields = [
        'warehouseStockOutOrder',
        'inWarehouseStockOutOrder',
        'stockInShortageOrder',
        'storageStockOutOrder',
        'inboundStockOutOrder'
      ]
      if (flagFields.some(field => row[field] === true || row[field] === 1 || row[field] === '1' || row[field] === '是' || row[field] === 'Y')) {
        return true
      }
      const typeFields = ['orderType', 'stockOutOrderType', 'shortageOrderType', 'sourceType']
      return typeFields.some(field => String(row[field] || '').includes('入仓缺货订单'))
    },
    init () {
      this.loading2 = true
      const data = {
        filterData: this.buildFilterData(),
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize
      }
      this.$q.orderDate.deliveryOrderList({ data }).then((res) => {
        if (res.success && res.data) {
          this.tableData = (res.data.records || []).filter(item => !this.isWarehouseStockOutOrder(item))
          this.paginationOpt = {
            ...this.paginationOpt,
            total: res.data.total || 0,
            pageNum: res.data.pageNum || 1
          }
        } else {
          this.tableData = []
          this.paginationOpt = { ...this.paginationOpt, total: 0 }
        }
      }).finally(() => {
        this.loading2 = false
      })
    },
    queryTabCount () {
      this.$q.orderDate.deliveryOrderNum({ data: this.buildFilterData(false) }).then((res) => {
        if (res.success && res.data) {
          this.tabCountMap = {
            allQty: res.data.allQty || 0,
            abnormalQty: res.data.abnormalQty || 0,
            normalQty: res.data.normalQty || 0,
            unrepliedQty: res.data.unrepliedQty || 0
          }
        }
      })
    },
    handleOrderTabChange () {
      this.paginationOpt.pageNum = 1
      this.init()
      this.queryTabCount()
    },
    openJournalDialog (row) {
      this.journalDialogVisible = true
      this.loading = true
      this.$q.orderDate.goodsStockOutLog({ data: { goodsCode: row.goodsCode, orderNo: row.orderNo } }).then((res) => {
        this.dialogData = res.success && Array.isArray(res.data) ? res.data : []
      }).finally(() => {
        this.loading = false
      })
    },
    openGoodsDetailDialog (row) {
      this.currentGoodsDetailRow = row
      this.goodsDetailDialogVisible = true
    },
    handleSortChange ({ prop, order }) {
      this.paginationOpt.pageSize = 30
      this.paginationOpt.pageNum = 1
      const fieldsName = {
        payTime: 'sortPayTime',
        orderDeliveryCycle: 'sortOrderDeliveryCycle',
        auditTime: 'sortOfAuditTime',
        deliveryTime: 'sortOfDeliveryTime'
      }
      const orderType = { ascending: 'ASC', descending: 'DESC' }
      this.orderParams = {}
      if (fieldsName[prop] && orderType[order]) {
        this.orderParams[fieldsName[prop]] = orderType[order]
      }
      this.init()
    },
    handleSizeChange (val) {
      this.paginationOpt.pageSize = val
      this.paginationOpt.pageNum = 1
      this.init()
    },
    handleCurrentChange (val) {
      this.paginationOpt.pageNum = val
      this.init()
    },
    exportExcel () {
      this.exportByColumns(this.columnDataExport, 'deliveryOrderListExport', 0)
    },
    exportDetailExcel () {
      this.exportByColumns(this.getDetailExportColumns(), 'deliveryOrderDetialListExport',  1)
    },
    getDetailExportColumns () {
      const detailExtraColumns = [
        { label: '缺货商品数量', prop: 'demandGoodsNum' },
        { label: '包件编码', prop: 'packCode' },
        { label: '包件名称', prop: 'packName' },
        { label: '包件可用库存', prop: 'stockNum' },
        { label: '缺货包件数量', prop: 'demandPackNum' },
        { label: '包件预计出货时间', prop: 'packShipmentTime' }
      ]
      const baseColumns = Array.isArray(this.columnDataExport) ? this.columnDataExport.slice() : []
      const existingLabels = new Set(baseColumns.map(item => item.label))
      const insertColumns = detailExtraColumns.filter(item => !existingLabels.has(item.label))
      const goodsNameIndex = baseColumns.findIndex(item => item.label === '缺货商品名称')

      if (goodsNameIndex === -1) {
        return baseColumns.concat(insertColumns)
      }

      baseColumns.splice(goodsNameIndex + 1, 0, ...insertColumns)
      return baseColumns
    },
    exportByColumns (columnList, reportName, boolExportDetail) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = {
        taskDTO: {
          appCode: 'ec-pc-new',
          paramMap: this.buildFilterData(),
          reportName
        },
        columnDTOs: []
      }
      columnList.forEach((item) => {
        params.columnDTOs.push({
          columnName: item.label,
          parentColumnName: null,
          fieldName: item.prop,
          fieldType: 'string',
          columnFormat: null
        })
      })
      params.columnDTOs = params.columnDTOs.filter(v => v.columnName !== '图片')
      params.taskDTO.paramMap.boolExportDetail = boolExportDetail
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查询')
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        loading.close()
      })
    },
    showOutOfstockRecordsModel () {
      if (this.global_outOfStockRecordsData) {
        this.currentGoodsDetailRow = this.global_outOfStockRecordsData
        this.goodsDetailDialogVisible = true
        this.$store.commit('operateAnalysis/SET_GLOBAL_OUTOFSTOCKRECORDSDATA', null)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-item
  height 100%

.toolbar-row
  display flex
  justify-content space-between
  align-items flex-end
  gap 12px
  margin-bottom 10px

.order-tab-row
  flex 1

.toolbar-buttons
  display flex
  gap 8px
  padding-bottom 6px

.footer-row
  display flex
  justify-content space-between
  align-items center
  margin 10px 0

.refresh-time
  color #555

.order-tab-row >>> .el-tabs__header
  margin-bottom 0

.multiline-cell-text
  white-space pre-line

.danger-text
  color #f56c6c

@media (max-width: 1200px)
  .toolbar-row,
  .footer-row
    flex-direction column
    align-items stretch
  .toolbar-buttons
    justify-content flex-end
</style>
